import * as React from 'react'
import { Files, SelectedFiles } from './with-file-state'
import { addFilesFn, removeFileFn } from './form-type-selector'
import { formatFileSize } from '../utils'
import { errorMsg } from './build-error-msg'
import { strings } from '../localization'

const filesListToArray = (files: FileList): Array<File> => {
  const array = []
  for (let index = 0; index < files.length; index++) {
    const file = files[index]
    array.push(file)
  }

  return array
}

const SelectedFilesComponent = ({ files, id, onRemove }) => {
  const handleRemoveKeyDown = (
    e: React.KeyboardEvent<HTMLElement>,
    id: string,
    position: number
  ) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      onRemove(id, position)
    }
  }
  return files.selectedFiles.map((current, position) => {
    return (
      <div key={current.localId} className='selected-file'>
        <div className='file-info'>
          <div className='file-info-name'>{current.file.name}</div>
          {current.error && (
            <div className='file-error'>{strings.fileUploadError}</div>
          )}

          {current.progress < 100 && !current.error && (
            <progress value={current.progress} max='100' />
          )}

          {current.progress >= 100 && !current.error && (
            <div>{formatFileSize(current.file.size)}</div>
          )}
        </div>
        <div className='remove-file'>
          <i
            className='material-icons'
            onClick={() => onRemove(id, position)}
            role='button'
            tabIndex={0}
            onKeyDown={(e) => handleRemoveKeyDown(e, id, position)}
            aria-label={strings.a11yRemove}
          >
            close
          </i>
        </div>
      </div>
    )
  })
}

const UploadFile = ({ onChange, files, data }) => {
  let inputElement = null

  return (
    <div className='upload-file-wrapper'>
      <div className='upload-file'>
        <input
          type='file'
          multiple
          ref={(input) => (inputElement = input)}
          style={{ display: 'none' }}
          onChange={onChange}
        />

        {files.selectedFiles.length === data.max_upload_files && (
          <div className='upload-count'>
            <div className='accentPrimary background' />
            {strings.fileUploadMaxFilesReached} {files.selectedFiles.length}/
            {data.max_upload_files}
          </div>
        )}

        {files.selectedFiles.length < data.max_upload_files && (
          <button
            className='button primary accentSecondary'
            onClick={() => inputElement.click()}
          >
            {data.label}
          </button>
        )}
      </div>
    </div>
  )
}

export function buildFileInput(
  data: {
    errorMessage?: string
    // eslint-disable-next-line camelcase
    field_type: string
    label: string
    // eslint-disable-next-line camelcase
    max_upload_files: number
    qid: string
    required: boolean
    requiredMessage: string
  },
  files: SelectedFiles,
  addFiles: addFilesFn,
  removeFile: removeFileFn
) {
  const onRemoveFile = (id, position) => removeFile(data.qid, position)
  const onChange = (e) => {
    addFiles(data.qid, filesListToArray(e.target.files), data.max_upload_files)
    // reset input
    e.target.value = ''
  }

  files =
    files === undefined
      ? { selectedFiles: [], overLimit: [], duplicated: [] }
      : files

  return (
    <div className='col-xs-12 file-input' key={data.qid}>
      <div className='input-line input-file-upload' id={data.qid}>
        <label htmlFor={data.qid}>
          <span>
            {strings.fileUploadAttachments}
            {` ${
              files.selectedFiles.length === 0
                ? '0'
                : files.selectedFiles.length
            }/${data.max_upload_files} `}
          </span>
          <span className='fieldRequired'>{data.required && '*'}</span>
          {data.errorMessage && errorMsg(data.qid, data.errorMessage)}
        </label>
      </div>

      <SelectedFilesComponent
        files={files}
        id={data.qid}
        onRemove={onRemoveFile}
      />

      <UploadFile onChange={onChange} files={files} data={data} />
    </div>
  )
}
